import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { addAboutItemToLast, pushToVersions, setSectionFormType, updateVersionIndex } from '../../../../../Features/storefrontSlice';
import CrossGray from '../../../../../Assets/StorefrontIcons/CrossGray.svg';
import FormInput from '../AboutOneForm/FormInput';

function AboutTwoForm() {
    const dispatch = useDispatch();

    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const {
        defaultAboutOne,
        aboutTwo,
        setAboutTwo,
    } = useContext(StorefrontContext);

    const defaultFormErrors = {
        heading: '',
        description: '',
    }

    const [formErrors, setFormErrors] = useState(defaultFormErrors);

    function handleChange(e) {
        const { name, value } = e.target;
        setAboutTwo({ ...aboutTwo, [name]: value });
    }

    function closeForm() {
        dispatch(setSectionFormType(null));
        setAboutTwo(defaultAboutOne);
    }

    async function handleSave() {
        const validationErrors = {};

        if(!aboutTwo.heading) {
            validationErrors.heading = 'Required field';
        }

        if(!aboutTwo.description) {
            validationErrors.description = 'Required field';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormErrors);

            const object = {
                TypeData: "ABOUT2",
                altText: "_",
                Heading: aboutTwo.heading,
                Description: aboutTwo.description,
            }

            const currentVersion = versionStack[versionIndex]

            const tempVersion = currentVersion?.storeAbout;

            const aboutTwoDataIndex = tempVersion.findIndex(item => item.item.TypeData === 'ABOUT2');

            const tempVersionData = [ ...tempVersion ];

            if (aboutTwoDataIndex !== -1) {
                tempVersionData[aboutTwoDataIndex] = {
                    ...tempVersionData[aboutTwoDataIndex],
                    item: object
                };

                const newIndex = versionStack[versionStack.length - 1].index + 1;

                const newVersion = {
                    ...currentVersion,
                    index: newIndex,
                    storeAbout: tempVersionData,
                    comment: 'Update About2 section',
                }

                dispatch(pushToVersions(newVersion));
                dispatch(updateVersionIndex(newIndex));
            }
            else {
                dispatch(addAboutItemToLast(object));
            }
            closeForm();
        }
        else {
            setFormErrors(validationErrors);
            return;
        }
    }

    useEffect(() => {
        function fetchData() {
            const tempVersion = versionStack[versionIndex]?.storeAbout;

            if(tempVersion.length > 0) {
                const { item: aboutTwoData = null } = tempVersion.find(item => item.item.TypeData === 'ABOUT2') || {};

                if(aboutTwoData) {
                    setAboutTwo({
                        heading: aboutTwoData.Heading,
                        description: aboutTwoData.Description,
                    });
                }
            }
        }

        fetchData();
        // eslint-disable-next-line
    }, [versionStack, versionIndex]);

    return (
        <div className='w-[305px] h-full bg-[#FFFFFF] border-l border-[#EAEAEA] flex flex-col gap-4 select-none relative'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>About 2</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={closeForm} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col gap-3 px-3 overflow-y-scroll no-scrollbar pb-16">
                <FormInput 
                    errorText={formErrors.heading} 
                    inputOptions={{
                        name: "heading",
                        id: "heading",
                        placeholder: 'Write heading here',
                        value: aboutTwo.heading,
                        onChange: handleChange,
                    }} 
                    title='Heading' 
                />

                <FormInput 
                    errorText={formErrors.description} 
                    inputOptions={{
                        name: "description",
                        id: "description",
                        placeholder: 'Write description here',
                        value: aboutTwo.description,
                        onChange: handleChange,
                    }} 
                    title='Description' 
                />
            </div>

            <div className="absolute bottom-0 left-0 w-full p-3 bg-[#FFFFFF]">
                <button onClick={handleSave} className='w-full outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Save changes</button>
            </div>
        </div>
    );
}

export default AboutTwoForm;
